import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "../config/axiosInstance";
import router from "../router";
import { DATE_FORMAT } from "../config/date";
import { NOTIFICATION_STATUS } from "../config/const";

Vue.use(Vuex);

export default new Vuex.Store({
    // * 상태 정의
    state: {
        theme: null,

        userInfo: {
            name: "",
            image_url: null,
            accessToken: null,
            refreshToken: null
        },

        saveEmail: "",
        defaultImageUrl: "https://s3.ap-northeast-2.amazonaws.com/kosirock.kosiwons.image/temp/f4e741ed993e1e6ec7366692031d39457f84baaa06a3f365a3d7856dcf698d0d.png",

        notificationList: [],

        selectedKosiwon: {
            name: "",
            branch: "",
            deposit: 0
        }
    },

    // * 정의된 상태값을 계산하여 return;
    getters: {
        isLoggedIn: state => {
            /**
             * * state에 userInfo Object를 순회하면서 해당 값이 모두 존재하면 로그인, 하나라도 존재하지 않는다면 로그인 X
             * ? 비어있지 않은 문자열 -> !"대선", !"tokenblahblah"는 false, !!"대선"은 true
             * ? "", null, undefined -> !""는 true, !!""는 false
             * ? 결론 : 명시적으로 boolean 값으로 강제 변환하기 위함.
             */
            return Object.keys(state.userInfo).some(key => !!state.userInfo[key]);
        },
        groupedNotifications: state => {
            return state.notificationList.reduce((acc, noti) => {
                const date = DATE_FORMAT(noti.created);
                if (!acc[date]) {
                    acc[date] = [];
                }
                acc[date].push(noti);
                return acc;
            }, {});
        },
        unreadNotificationsCnt: state => {
            return state.notificationList.filter(noti => !noti.is_read).length;
        }
    },

    // * 상태를 변화시키는 메소드
    mutations: {
        /** 
         * * 최초 홈페이지 접근 시, index.html -> app.js가 로드되면서 new ThemeCustomize() 함수가 실행됨.
         * * 하지만 SPA 특성 상 최초에 한번 실행되고 로그인 후, AdminWrapper에 상단바 사이드바 액션에 영향을 주는 
         * * new ThemeCustomize() 함수가 다시 실행되어야 함. 그래서 AdminWrapper Mounted 시, 함수 재실행
        */
        SET_THEME(state) {
            state.theme = new ThemeCustomizer();
            state.theme.init();
        },
        // * AdminWrapper 내에서, 페이지 이동이 일어날 시 사이드바 닫는 구문
        CLOSE_SIDE_BAR(state) {
            if (state.theme) {
                state.theme.html.classList.remove("sidebar-enable");
                state.theme.hideBackdrop();
            }
        },

        SET_TOKEN(state, { accessToken, refreshToken }) {
            state.userInfo.accessToken = accessToken;
            state.userInfo.refreshToken = refreshToken;
        },
        SET_SAVE_EMAIL(state, email) {
            state.saveEmail = email;
        },
        DEL_SAVE_EMAIL(state) {
            state.saveEmail = "";
        },
        SET_USERINFO(state, userInfo) {
            state.userInfo.name = userInfo.name;
            state.userInfo.image_url = userInfo.image_url || state.defaultImageUrl;
        },
        DEL_USERINFO(state) {
            state.userInfo.name = "";
            state.userInfo.image_url = null;
            state.userInfo.accessToken = null;
            state.userInfo.refreshToken = null;
        },

        SET_SELECTED_KOSIWON(state, kosiwon) {
            state.selectedKosiwon = kosiwon;
        },

        SET_NOTIFICATION(state, notificationList) {
            state.notificationList = notificationList.map(noti => {

                const status = NOTIFICATION_STATUS[noti.message_type] || NOTIFICATION_STATUS.default;

                return {
                    ...noti,
                    btn_text: status.btn_text,
                    btn_color: status.btn_color,
                    bg_color: status.bg_color,
                    is_read: noti.userNotification[0].is_read
                };
            });
        },
        READ_NOTIFICATION(state, pk) {
            state.notificationList = state.notificationList.map(noti => {
                if (noti.pk === pk) {
                    return {
                        ...noti,
                        is_read: true
                    };
                }
                return noti;
            });
        },
        ALL_READ_NOTIFICATION(state) {
            /* 
             * 반응성 보장: Vue는 배열의 항목이 교체되거나 배열 자체가 새로 할당될 때 변화를 감지하고 반응합니다. 배열의 항목이 직접 수정될 때와 달리, 배열의 재할당은 Vue의 반응성 시스템에 더 명확하게 변화를 전달합니다.
             * 명시적 재할당: 새 배열을 생성하고 원래 배열을 업데이트된 배열로 재할당하면, Vue는 이 변경을 감지하고 컴포넌트를 다시 렌더링합니다.
            */
            state.notificationList = state.notificationList.map(noti => {
                return {
                    ...noti,
                    is_read: true
                };
            });
        },

        INIT_BOOTSTRAP_WIZARD(_, id) {
            $(`#${id}`).bootstrapWizard({
                onTabShow: (_, r, a) => {
                    a = (a + 1) / r.find("li").length * 100;
                    $(`#${id}`).find(".bar").css({
                        width: a + "%"
                    });
                },
                nextSelector: ".button-next",
                previousSelector: ".button-previous",
                firstSelector: ".button-first",
                lastSelector: ".button-last"
            });
        },
        INIT_RANGE_SLIDER() {
            ! function (n) {
                "use strict";

                function i() {
                    this.$body = n("body")
                }
                i.prototype.init = function () {
                    n('[data-plugin="range-slider"]').each(function () {
                        var i = n(this).data();
                        n(this).ionRangeSlider(i)
                    })
                }, n.RangeSlider = new i, n.RangeSlider.Constructor = i
            }(window.jQuery),
                function () {
                    "use strict";
                    window.jQuery.RangeSlider.init()
                }();
        },
        INIT_TOOLTIP() {
            const tooltipTriggerList = document.querySelectorAll("[data-bs-toggle='tooltip']");
            [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
        },
        INIT_SELECT2() {
            $("[data-toggle='select2']").select2();
        }
    },

    // * 변화를 커밋하는 액션 정의
    actions: {
        async login({ commit }, userInfo) {
            try {
                const res = await axios.post("/login", userInfo);

                commit("SET_USERINFO", res.data.result);

                commit("SET_TOKEN", {
                    accessToken: res.data.result.accessToken,
                    refreshToken: res.data.result.refreshToken,
                });

                return res;
            } catch (error) {
                // ? throw를 하지 않으면 에러는 현재지점에서 종결되고 전파되지 않음.
                /**
                 * * 동작 원리
                 * * Vuex에 actions는 비동기 작업을 처리할 때, 일반적으로 promise를 반환.
                 * * async를 사용하는 경우, 함수 내에서 발생한 예외가 catch 블록으로 전달되고 더 이상 외부로 던져지지 않는다면,
                 * * 이 함수는 성공적으로 해결된 promise (resolved promise)를 반환한다. 이는 외부에서는 에러가 발생되지 않았다고 인식됨.
                */
                throw error;
            }
        },
        async logout({ commit }) {
            try {
                await axios.post("/logout");
                commit("DEL_USERINFO");
                router.push("/");
            } catch (error) {
                console.log(error);
            }
        },
        async fetchNotification({ commit }) {
            try {
                const res = await axios.get("/notification");
                commit("SET_NOTIFICATION", res.data.result);
            } catch (error) {
                console.log(error);
            }
        },
        async readNotification({ commit }, pk) {
            try {
                await axios.put(`/notification/read/${pk}`);
                commit("READ_NOTIFICATION", pk);
            } catch (error) {
                console.log(error);
            }
        },
        async allReadNotification({ commit }) {
            try {
                await axios.put("/notification/read-all");
                commit("ALL_READ_NOTIFICATION");
            } catch (error) {
                console.log(error);
            }
        }
    },

    // * What is vuex-persistedstate?
    // - Vuex store state값은 새로고침 시 초기화 된다.
    // - 위의 상황을 방지하고자 모든 state 값의 변경사항을 localstorage에서 관리해주는 plugins
    plugins: [createPersistedState()]
});
